import { useLocalStore } from 'mobx-react-lite';
import { useEffect } from 'react';

import { ICommonPopupsProps } from '@gem/popups';
import { PopupStore } from '@gem/popups';

import Tasks from 'APP/Tasks';
import { StickerPackPopup } from 'APP/main/PopupManager/Popups/StickerPackPopup/StickerPackPopup';
import { IStickerPackExtend } from 'APP/model/stickers/stickersModel.types';

interface IStickersSettingsPopupPresenter {
  childPopup: PopupStore | null;
  onClose(): void;
  openStickerPackPopup(stickerPack: IStickerPackExtend): void;
}

export function useStickersSettingsPopupPresenter({
  popupInstance,
}: ICommonPopupsProps): IStickersSettingsPopupPresenter {
  const presenter = useLocalStore<IStickersSettingsPopupPresenter>(() => ({
    childPopup: null,

    onClose(): void {
      popupInstance.close();
    },

    openStickerPackPopup(stickerPack: IStickerPackExtend): void {
      popupInstance.hide();

      presenter.childPopup = Tasks.app.openPopup(StickerPackPopup, {
        params: {
          stickerPackId: stickerPack.stickerPack.id,
        },
        onBack: () => popupInstance.show(),
        onClose: () => presenter.onClose(),
      });
    },
  }));

  useEffect(() => {
    return () => presenter.childPopup?.close();
  }, []);

  return presenter;
}
